export enum PageTab {
  Active = 'active',
  Drafts = 'drafts',
  Archived = 'archived'
}
